/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RegisterResponse {
  /**
  * The account ID
  */
  'accountId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "accountId",
      "baseName": "accountId",
      "type": "string",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return RegisterResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

